const angular = require('angular')
const isEmpty = require('lodash/isEmpty')
const map = require('lodash/map')

const serverConfig = require('js/infrastructure/serverConfig')
const previewImage = require('js/infrastructure/previewImage.js')
require('js/services/module')

/* Directives */
module.exports = angular.module('hxphone.compose.composeDirectives', ['hxphone.services', 'hxphone.controllers'])
  .directive('composeEmailEdit', ['$q', '$rootScope', '$document', '$timeout', '$translate', '$utils',
    '$sectionContact', '$message', '$phoneModal', 'contactService', 'User', 'Promise', 'contactListService',
    function ($q, $rootScope, $document, $timeout, $translate,
      $utils, $sectionContact, $message, $phoneModal, contactService, User, Promise, contactListService) {
      return {
        replace: true,
        templateUrl: 'compose-email-edit.html',
        scope: {
          'emails': '=' // 绑定当前的邮件对象（to，cc，bcc）的其中之一
        },
        restrict: 'A',
        link: function (scope, element, attr) {
          scope.inputLabel = '' // 本控件的标签值
          scope.emails = scope.emails || []
          scope.active = false // 标记本控件是否处于active状态
          const sType = attr['composeEmailEdit'].toLowerCase() // 本控件的类型，如'收件人'
          scope.id = sType
          scope.enableContactSelectEntrance = $rootScope.settings.featureControl.addressBook.enableContactSelectEntrance
          // 获取输入框相关的dom节点
          const eInputEx = element.children().eq(1)
          const eInputBox = eInputEx.children().eq(eInputEx.children().length - 2)
          const eInputArea = eInputBox.children().eq(0)
          // 设置label的值
          $translate('MAIL.' + sType.toUpperCase()).then(function (msg) {
            scope.inputLabel = msg
          })
          // 监听当前的composeItem的active状态
          scope.$watch(function () {
            return scope.active
          }, function (value) {
            if (!value && scope.emails.length !== 0) {
              showContactSummary()
              scope.hideInput = true
            }
            if (value) {
              scope.hideInput = false
            }
          })
          // 监听emails的值的变化
          scope.$watch(function () {
            return scope.emails.length
          }, function (value) {
            if (value !== 0 && !scope.active) {
              showContactSummary()
              scope.hideInput = true
            }
          })
          addeInputAreaListener()
          // 添加eInputArea的事件监听
          function addeInputAreaListener() {
            // input value change 的时候搜索，部分机型中文输入的时候keyup 监听不到, 比keyup先执行
            const debounceSearch = deBounce(doSearchContact, 400)
            eInputArea.on('input', function (e) {
              debounceSearch(e)
            })

            eInputArea.on('keyup', function ($event) {
              const sEmail = eInputArea.val()
              const keyCode = $event.keyCode

              if (keyCode == 8 && sEmail.length == 0) { // del键
                if (scope.emails.length > 0) {
                  scope.emails.pop()
                }
                scope.$parent.enableSendButton()
                scope.$apply()
                return
              }
              // ;键 enter键 或空格键
              if (keyCode == 186 || keyCode == 13 || keyCode == 32) {
                addEmail(sEmail.trim(), true)
                return
              }

              // 华为p7 自带浏览器keycode都为0
              // chrome 浏览器出现keycode 为229
              if ((/;|\s$/).test(sEmail)) { // ;键 或空格键
                addEmail(sEmail.trim(), true)
              }

              // 处理 email + 逗号的情况
              if ($utils.$email.validate(sEmail.substring(0, sEmail.length - 1)) && keyCode === 188) {
                addEmail(sEmail.trim(), true)
              }
            })

            eInputArea.on('blur', function ($event) {
              setTimeout(function () {
                const sEmail = eInputArea.val()
                addEmail(sEmail.trim(), true)
              }, 100)
            })
          }
          // 自动匹配联系人的防抖动包装函数
          let contactSearchTimer = null
          function deBounce(fn, delay) {
            return function () {
              const context = this
              const args = arguments
              clearTimeout(contactSearchTimer)
              contactSearchTimer = setTimeout(function () {
                fn.apply(context, args)
              }, delay)
            }
          }
          // 自动匹配联系人
          function doSearchContact() {
            const sEmail = eInputArea.val()
            if (sEmail && sEmail.trim().length &&
              (!/;|\s$/.test(sEmail) || (!sEmail.validate(sEmail.substring(0, sEmail.length - 1)) && sEmail[sEmail.length - 1] === ','))) {
              scope.$parent.setEmailEditing(true)
              $rootScope.$emit('COMPOSE_SHOW_CONTACTS_' + sType, sEmail)
            } else {
              if (!sEmail || !sEmail.trim().length) {
                $rootScope.$emit('COMPOSE_SHOW_CONTACTS_' + sType, '')
              }
              scope.$parent.setEmailEditing(false)
            }
          }
          // 根据联系人数组显示联系人概要，如'小明，小红，小伟...等8人'
          function showContactSummary() {
            scope.contactSummary = ''
            scope.emails.showSummaryTail = false
            const temp = []
            scope.emails.forEach(function (email) {
              let name = ''
              const parseResult = $utils.$email.parseTrueName(email.address)
              if (!parseResult) {
                name = $utils.$email.parse(email.address).addr.split('@')[0]
              } else {
                name = parseResult
              }
              temp.push(name)
            })
            scope.contactSummary = temp.join('、')
            scope.contactSummaryTail = $translate.instant('COMPOSE.CONTACTSUMMARYTAIL', { count: temp.length })
            setTimeout(function () {
              let contactSummaryContentNode = null
              contactSummaryContentNode = element.children().eq(1).children().eq(0).children()[0]
              if (contactSummaryContentNode.clientWidth < contactSummaryContentNode.scrollWidth) {
                scope.emails.showSummaryTail = true
                scope.$digest()
              }
            })
          }
          // 删除email
          scope.deleteEmail = function (index) {
            scope.emails.splice(index, 1)
          }
          // 打开联系人详情模态框
          scope.openContactDetailModal = function (contact) {
            const result = $utils.$email.parse(contact.address)
            scope.getContactDetail(result)
            scope.contactDetailModal = $phoneModal.fromTemplate(
              require('views/compose/contactDetailModal.html'),
              {
                scope: scope,
                animation: 'slide-in-up'
              }
            )
            scope.contactDetailModal.el.style.zIndex = 11
            scope.contactDetailModal.show()
          }
          // 关闭联系人详情模态框
          scope.closeContactDetailModal = function () {
            scope.contactDetailModal.remove()
          }
          // 获取联系人详情, 按照组织通讯录--个人通讯录--默认值的优先级依次查找信息显示
          scope.getContactDetail = function (info) {
            if (!info.addr) return

            scope.isLoading = true
            // id是邮件地址需要先获取该邮件地址的id，否则oab:get无法获取外部联系人
            const contactDefer = $utils.$email.test(info.addr) ? contactService.searchOabContacts(info.addr) : $q.resolve(info.addr)
            contactDefer.then(function(result) {
              if (!isEmpty(result)) {
                scope.detail = result[0]
                scope.avatarInfo = { email: scope.detail['@id'], name: scope.detail['true_name'] }
                scope.contactShow = serverConfig.contactsAttrShow('oab') // 通讯录的显示隐藏配置
                scope.contactShow.orgname = true // 由于组织通讯录不存在orgname的显示隐藏配置，这里要和个人通讯录共用，故手动设置
              } else {
                return contactService.searchPabContactByEmail(info.addr).then((data) => {
                  if (data.code === 'S_OK' && data.var.length !== 0) {
                    return contactService.getContactDetail(data.var[0].id).then((data) => {
                      scope.detail = {}
                      data['FN'] && (scope.detail.name = data['FN'])
                      data['EMAIL;PREF'] && (scope.detail.email = data['EMAIL;PREF'])
                      data['ORGNAME'] && (scope.detail.orgName = data['ORGNAME'])
                      data['TEL;CELL;VOICE'] && (scope.detail.mobile_number = data['TEL;CELL;VOICE'])
                      data['TEL;HOME;VOICE'] && (scope.detail.home_number = data['TEL;HOME;VOICE'])
                      data['TEL;WORK;FAX'] && (scope.detail.fax_number = data['TEL;WORK;FAX'])
                      data['TEL;WORK;VOICE'] && (scope.detail.company_phone = data['TEL;WORK;VOICE'])
                      scope.avatarInfo = { email: scope.detail.email, name: scope.detail.name } // 默认值
                      scope.contactShow = serverConfig.contactsAttrShow('ldvcapp') // 通讯录的显示隐藏配置
                    })
                  } else {
                    scope.detail = {}
                    scope.detail.email = info.addr // 默认值
                    scope.detail.name = info.name // 默认值
                    scope.avatarInfo = { email: scope.detail.email, name: scope.detail.name } // 默认值
                    scope.contactShow = {} // 通讯录的显示隐藏配置
                  }
                })
              }
            }).finally(function () {
              scope.isLoading = false
            })
          }
          scope.emailItemMaxWidthStyle = { 'max-width': 'auto' }
          // 动态计算并计算每个EmailItem的最大宽度值，只在!active时使用
          function calculateEmailItemMaxWidth() {
            scope.emailItemMaxWidthStyle = { 'max-width': (($document.find('body')[0].clientWidth - 220) / 2) + 'px' }
          }

          calculateEmailItemMaxWidth()
          $rootScope.$emit('GLOBAL_ADD_WINDOW_RESIZE_FUN', calculateEmailItemMaxWidth)
          /**
           * 整个Item的点击事件分发函数，只在模板上监听此函数
           * 对应的所有点击均根据点击对象的itemType属性来对应处理
           */
          scope.handleItemClick = function ($event) {
            if (!scope.active) {
              $rootScope.$emit('COMPOSE_ACTIVE_EMAIL_EDIT', sType)
              // 数据埋点
              switch (sType) {
                case 'to':
                  LA.track('A1D2C1')
                  break
                case 'cc':
                  LA.track('A1D2C2')
                  break
                case 'bcc':
                  LA.track('A1D2C3')
                  break
              }
              eInputArea[0].focus()
            } else {
              let target = angular.element($event.target)
              while (!target.attr('itemType')) {
                target = target.parent().eq(0)
              }
              removeSelected()
              switch (target.attr('itemType')) {
                case 'email':
                  const iIndex = parseInt(target.attr('emailIndex'))
                  scope.emails[iIndex].selected = true
                  eInputArea[0].blur()
                  break
                case 'input':
                  $rootScope.$emit('COMPOSE_HIDE_SELECTED_ADDRESS_' + sType)
                  break
                case 'contact':
                  addContact()
                  eInputArea[0].blur()
                  break
                default:
                  $rootScope.$emit('COMPOSE_HIDE_SELECTED_ADDRESS_' + sType)
                  eInputArea[0].focus()
                  break
              }
            }
          }
          // 重置选中状态
          function removeSelected() {
            if (scope.emails) {
              for (let i = 0; i < scope.emails.length; i++) {
                scope.emails[i].selected = false
              }
            }
            $rootScope.$emit('COMPOSE_HIDE_SELECTED_ADDRESS_' + sType)
          }

          // 事件响应
          $rootScope.$on('COMPOSE_EDIT_DELETE_SELECTED_' + sType, function ($event, iIndex) {
            scope.emails.splice(iIndex, 1)
          })

          $rootScope.$on('COMPOSE_EDIT_ADD_ADDRESS_' + sType, function ($event, address) {
            addEmail(address)
            triggerFocusAndClearInput()
          })

          scope.$on('COMPOSE_ACTIVE_EMAIL_EDIT', function ($event, type) {
            const typeArr = [].concat(type)
            if (~typeArr.indexOf(sType)) {
              sType === 'to' && $rootScope.$emit('COMPOSE_SUMMARY_ACTIVE_CHECK')
              scope.active = true
            } else {
              scope.active = false
              removeSelected()
            }
            if (scope.$root.$$phase != '$apply' && scope.$root.$$phase != '$digest') {
              scope.$digest()
            }
          })

          scope.checkEmail = function () {
            scope.$broadcast('BLUR_EMAIL_ITEM_EDIT_INPUT')
          }

          scope.$on('BLUR_EMAIL_ITEM_EDIT_INPUT', function () {
            eInputArea[0].blur()
            const sEmail = eInputArea.val()
            if (sEmail.length) {
              addEmail(sEmail, false)
              triggerFocusAndClearInput()
            }
          })

          // 析构本个scope时取消所有对rootScope事件的监听
          scope.$on('$destroy', function () {
            $rootScope.$off('COMPOSE_EDIT_ADD_ADDRESS_' + sType + ' ' +
              'COMPOSE_EDIT_DELETE_SELECTED_' + sType)
            $rootScope.$emit('GLOBAL_REMOVE_WINDOW_RESIZE_FUN', calculateEmailItemMaxWidth)
          })

          scope.$on('commitSelectedUser', function (event, data) {
            angular.forEach(data, function (item, index) {
              let name = item.name ? item.name : ''
              name = item.true_name ? item.true_name : name
              name = item['FN'] ? item['FN'] : name
              const email = item.email || item.addr || item['EMAIL;PREF']
              const addr = '"' + name + '"' + ' <' + email + '>'
              addEmail(addr, false)
              triggerFocusAndClearInput()
            })

            scope.selectFilesModal.remove()
          })

          function addContact() {
            scope.selectFilesModal = $phoneModal.fromTemplate(
              require('views/addressBook/selectContactListModal.html'),
              {
                scope: scope,
                animation: 'fade-in-up'
              }
            )
            scope.selectFilesModal.el.style.zIndex = 11
            scope.selectFilesModal.show()
          }

          /**
           * 添加单个邮件地址的接口
           * @param sEmail 欲添加的邮件地址
           * @param apply 是否触发dirty check
           */
          function addEmail(sEmail, apply) {
            if (sEmail.length == 0 || !(sEmail.trim())) {
              return
            }
            const existEmails = {}
            const aEmails = $utils.$email.parseList(sEmail)

            scope.emails = scope.emails || []
            for (let i = 0; i < scope.emails.length; i++) {
              const addr = $utils.$email.parse(scope.emails[i].address).addr
              if (!existEmails[addr]) {
                existEmails[addr] = scope.emails[i]
              }
            }

            for (let j = 0; j < aEmails.length; j++) {
              const parsedEmail = aEmails[j].addr
              if (!existEmails[parsedEmail] && parsedEmail) {
                scope.emails.push({
                  address: $utils.$email.toString(aEmails[j]),
                  selected: false,
                  valid: $utils.$email.validate(parsedEmail)
                })
              }
            }
            eInputArea.val('')
            $rootScope.$emit('COMPOSE_HIDE_SELECTED_ADDRESS_' + sType)
            scope.emailInput = ''
            if (apply) {
              scope.$apply()
            }
          }

          // 搜索联系人列表或弹窗选择联系人后，focus当前input并且清空
          function triggerFocusAndClearInput() {
            $timeout(function () {
              eInputArea[0].focus()
              eInputArea.val('')
            }, 200)
          }
        }
      }
    }
  ])
  .directive('composeEmailShow', ['$q', '$rootScope', '$document', '$timeout', '$utils', '$message', 'contactService',
    function ($q, $rootScope, $document, $timeout, $utils, $message, contactService) {
      return {
        replace: true,
        templateUrl: 'compose-email-show.html',
        scope: {},
        restrict: 'A',
        link: function (scope, element, attr) {
          // 单个联系人预览删除相关
          scope.active = false // 标记是否显示此项
          scope.mode = 'normal' // 标记当前控件的状态，自动匹配搜索、点选删除、普通模式（隐藏）
          scope.address = '' // 标记当前需要显示的address
          const sType = attr['composeEmailShow'] // 常量，记录类型，用于构造自己的事件名字
          let emailItemIndex = null // 缓存当前选中并显示详情的email的index，用于后面回调
          // inputItem点击监听器
          $rootScope.$on('COMPOSE_SHOW_SELECTED_ADDRESS_' + sType,
            function ($event, iIndex, address) {
              scope.active = true
              scope.address = address
              emailItemIndex = iIndex
              scope.mode = 'delete'
            })

          $rootScope.$on('COMPOSE_HIDE_SELECTED_ADDRESS_' + sType,
            function ($event) {
              scope.mode = 'normal'
              scope.contacts = []
            })
          // 删除联系人
          scope.delEmail = function () {
            $rootScope.$emit('COMPOSE_EDIT_DELETE_SELECTED_' + sType, emailItemIndex)
            scope.mode = 'normal'
            scope.address = ''
          }

          // 多个联系人的搜索相关
          scope.contacts = []
          $rootScope.$on('COMPOSE_SHOW_CONTACTS_' + sType, function ($event, key) {
            if (key && key.length) {
              contactService.searchContacts(key, true, '<b>').then(function (results) {
                scope.contacts = results
                scope.mode = 'search'
              })
            } else {
              scope.mode = 'normal'
            }
          })

          scope.addContact = function ($index, $event) {
            const selectedContact = scope.contacts[$index]
            let addr = selectedContact.addr
            if (selectedContact.name && selectedContact.name.trim().length > 0) {
              addr = '"' + selectedContact.name + '"' + ' <' + selectedContact.addr + '>'
            }

            $rootScope.$emit('COMPOSE_EDIT_ADD_ADDRESS_' + sType, addr)
            scope.mode = 'normal'
            scope.contacts = []
            $event && $event.stopPropagation()
          }

          // 析构本个scope时取消所有对rootScope事件的监听
          scope.$on('$destroy', function () {
            $rootScope.$off(
              'COMPOSE_SHOW_SELECTED_ADDRESS_' + sType + ' ' +
              'COMPOSE_HIDE_SELECTED_ADDRESS_' + sType + ' ' +
              'COMPOSE_SHOW_CONTACTS_' + sType)
          })
        }
      }
    }
  ])

  // 只为了select控件的长度能适应整个屏幕的宽度
  .directive('composeEmailSender', ['$rootScope', '$window', '$document', function ($rootScope, $window, $document) {
    return {
      replace: false,
      restrict: 'A',
      scope: true,
      link: function (scope, element, attr) {
        const position = function () {
          element.css({ 'width': ($document.find('body')[0].clientWidth - 70) + 'px' })
        }
        position()

        scope.$on('destroy', function () {
          $rootScope.$emit('GLOBAL_REMOVE_WINDOW_RESIZE_FUN', position)
        })
        $rootScope.$emit('GLOBAL_ADD_WINDOW_RESIZE_FUN', position)
      }
    }
  }])
  .directive('switchInput', [function () {
    return {
      replace: true,
      restrict: 'A',
      scope: {},
      link: function (scope, ele) {
        const inputs = document.getElementsByClassName('input-switch')
        const mainBody = document.getElementById('compose-edit-zone')
        const len = inputs.length
        const indexArr = []
        for (let i = 0; i < len; i++) {
          if (inputs[i].ng339) {
            indexArr.push(inputs[i].ng339)
          }
        }
        ele.count = 0
        ele[0].onkeypress = function (e) {
          if (e.keyCode === 13) {
            if (e.target.className.indexOf('subject') >= 0) {
              mainBody.focus()
            } else {
              ele.count += 1
              if (ele.count === 2) {
                const i = indexArr.indexOf(ele[0].ng339)
                inputs[i + 1].focus()
                ele.count = 0
              }
            }
          }
        }
      }
    }
  }])
  .directive('contenteditable', ['$ionicScrollDelegate', '$translate', '$utils',
    function ($ionicScrollDelegate, $translate, $utils) {
      return {
        link: function (scope, element) {
          initPlaceholder()

          element.on('click', function (event) {
            // 如果点击的是图片的话，打开单独的图片浏览器
            if (event.target.nodeName === 'IMG') {
              previewImage.start({
                urls: map(element.find('img'), item => item.src),
                current: event.target.src
              })
            }
          })
          // focus时清除编辑区占位信息
          element.on('focus', function () {
            element[0].setAttribute('placeholder', '')
          })
          // blur时回复编辑区占位信息
          element.on('blur', function () {
            if (element[0] && !element[0].innerHTML.match(/[^(<br>)]/ig)) {
              element[0].setAttribute('placeholder', $translate.instant('COMPOSE.COMPOSE_INPUT_CONTENT_TIPS'))
            }
          })
          // 占位信息初始化
          function initPlaceholder() {
            if (element[0] && !element[0].innerHTML.match(/[^(<br>)]/ig)) {
              element[0].setAttribute('placeholder', $translate.instant('COMPOSE.COMPOSE_INPUT_CONTENT_TIPS'))
            } else {
              element[0].setAttribute('placeholder', '')
            }
          }
        }
      }
    }])
  .directive('resizeDetection', [
    function () {
      return {
        restrict: 'A',
        link: function ($scope, elem) {
          $scope.$watch(
            function () {
              return elem[0].offsetHeight
            },
            function (value) {
              $scope.$emit('COMPOSE.CONTENT_LOADED')
            }
          )
        }
      }
    }
  ])



// WEBPACK FOOTER //
// ./src/js/mail/compose/composeDirectives.js